export default __webpack_public_path__ + "static/media/ky.0ed24290.svg";